import {
  Box,
  Button,
  Checkbox,
  HStack,
  Icon,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FaCheckCircle, FaFileContract } from "react-icons/fa";
import { TipTap } from "../../../../../common/input/TipTap/TipTap";

interface Props {
  termsHtml: string;
  accepted: boolean;
  onAccept: () => void;
  isAccepting: boolean;
}

export const TermsAcceptancePanel = ({ termsHtml, accepted, onAccept, isAccepting }: Props) => {
  const { t } = useTranslation();
  const { isOpen, onOpen, onClose } = useDisclosure();
  return (
    <Box
      borderWidth="1px"
      borderColor={accepted ? "smSuccessSoftBorder" : "smBorder"}
      borderRadius="lg"
      bg="smBackground"
      boxShadow="sm"
      p={{ base: "4", md: "5" }}
    >
      <Stack spacing="3">
        <HStack justify="space-between" align="center" spacing="3">
          <Text fontSize="sm" fontWeight="semibold">
            {t("Buyer's terms and conditions")}
          </Text>
          <Button
            size="sm"
            variant="outline"
            flexShrink={0}
            leftIcon={<Icon as={FaFileContract} boxSize="3.5" />}
            onClick={onOpen}
          >
            {t("Read the terms")}
          </Button>
        </HStack>
        {accepted ? (
          <HStack spacing="2" color="smSuccess">
            <Icon as={FaCheckCircle} boxSize="4" />
            <Text fontSize="sm" fontWeight="medium">
              {t("The conditions are accepted")}
            </Text>
          </HStack>
        ) : (
          <Checkbox
            colorScheme="teal"
            isDisabled={isAccepting}
            onChange={(e) => {
              if (e.target.checked) onAccept();
            }}
            sx={{ ".chakra-checkbox__label": { opacity: 1 } }}
          >
            <Text fontSize="sm">{t("I have read and understood the conditions")}</Text>
          </Checkbox>
        )}
      </Stack>
      <Modal isOpen={isOpen} onClose={onClose} size="xl" scrollBehavior="inside" isCentered>
        <ModalOverlay />
        <ModalContent bg="smBackground">
          <ModalHeader>{t("Buyer's terms and conditions")}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <TipTap content={termsHtml} editable={false} maxHeight="full" hasBorder={false} />
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="teal" onClick={onClose}>
              {t("Close")}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};
